module.exports = __webpack_public_path__ + "media/images/noticias/viejas/noti_mujer/tomografia-1d326f8b1125231667edfaeabb7e058b.jpg";